import ReportsAPI from 'dashboard/api/reports';
import { formatUnixDate } from 'shared/helpers/DateHelper';

const PAGE_SIZE = 25;
const MAX_PAGES = 10000;
const CONVERSATION_STATUS_LABELS = {
  open: 'Aberta',
  resolved: 'Resolvida',
  pending: 'Pendente',
  snoozed: 'Adiada',
};

const formatConversationDate = (timestamp, dateFormat) =>
  timestamp ? formatUnixDate(timestamp, dateFormat) : '';

const conversationLink = conversation =>
  conversation.account_id && conversation.id
    ? `${window.location.origin}/app/accounts/${conversation.account_id}/conversations/${conversation.id}`
    : '';

export const downloadXlsxFile = async (fileName, sheets) => {
  const XLSX = await import('xlsx');
  const workbook = XLSX.utils.book_new();

  sheets.forEach(({ name, rows }) => {
    const worksheet = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(workbook, worksheet, name.slice(0, 31));
  });

  const normalizedFileName = fileName.endsWith('.xlsx')
    ? fileName
    : `${fileName}.xlsx`;
  XLSX.writeFile(workbook, normalizedFileName, { compression: true });
};

export const fetchAllConversationsList = async params => {
  const fetchPage = async (page, records = []) => {
    const response = await ReportsAPI.getConversationsList({
      ...params,
      page,
    });
    const pageRecords = Array.isArray(response.data) ? response.data : [];
    const allRecords = [...records, ...pageRecords];

    if (pageRecords.length === PAGE_SIZE && page < MAX_PAGES) {
      return fetchPage(page + 1, allRecords);
    }

    return allRecords;
  };

  return fetchPage(1);
};

export const conversationRowsForExport = conversations =>
  conversations.map(conversation => ({
    'Código do cliente': conversation.contact?.id || '',
    Cliente: conversation.contact?.name || '',
    Telefone: conversation.contact?.phone_number?.replace(/\+55/g, '') || '',
    'Agente responsável': conversation.assignee?.name || '',
    Protocolo: conversation.id || '',
    'Data do atendimento': formatConversationDate(
      conversation.created_at,
      'dd/MM/yyyy'
    ),
    'Hora do atendimento': formatConversationDate(
      conversation.created_at,
      'HH:mm:ss'
    ),
    'Última atividade': formatConversationDate(
      conversation.last_activity_at,
      'dd/MM/yyyy HH:mm:ss'
    ),
    'Caixa de entrada': conversation.inbox?.name || '',
    Status: CONVERSATION_STATUS_LABELS[conversation.status] || '',
    Etiquetas: conversation.labels?.join(', ') || '',
    'Atributos adicionais': JSON.stringify(
      conversation.additional_attributes || {}
    ),
    'Link da conversa': conversationLink(conversation),
  }));
